export default __webpack_public_path__ + "static/red-crescent-cc219b478c7144e1268f1bad8db0afc2.jpg";